export const ENDPOINT_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const ENDPOINT_AUTH_URL = process.env.REACT_APP_API_AUTH_URL;
export const ENDPOINT_FILE_URL = process.env.REACT_APP_API_FILE_URL;
